const EventEmitter = require('eventemitter3');

const BattleCalc = require('../../BattleCalc');
const BlessedCondition = require('../../conditions/BlessedCondition');
const RecuperatingCondition = require('../../conditions/RecuperatingCondition');
const { logError } = require('../../logger');

const Bless = function(battleState) {
  this.handle = 'bless';
  this.magic = true;
  this.ranged = true;
  this.help = true;

  this.eventEmitter = new EventEmitter();

  this.isLegal = function(actor, victim) {
    return victim && victim.unit;
  };

  this.execute = function(actor, victim) {
    if (!actor || !actor.inPlay || !victim || (victim.unit&&!victim.inPlay)) {
      return { success: false };
    }

    try {
      var ability = BattleCalc.getEquippedAbility(actor, this.handle);

      var result = {};

      const blessed = new BlessedCondition(
        actor,
        victim,
        battleState,
        ability.potency,
        ability.duration,
      );
      blessed.actorId = actor.uid;
      blessed.victimId = victim.uid;
      battleState.onUnitCondition(blessed);
      result.blessed = blessed;

      var recuperating = new RecuperatingCondition(actor, victim, battleState, ability.healing, ability.duration);
      battleState.onUnitCondition(recuperating);
      result.recuperating = recuperating;

      result.abilityHandle = this.handle;
      result.actorId = actor.uid;
      result.victimId = victim? victim.uid : null;
      result.allPieces = battleState.allPieces;
      this.eventEmitter.emit('result', result);
    } catch (err) {
      logError(err, {
        module: 'Bless',
        func: 'execute',
        actor,
        victim,
      });

      return { success: false };
    }
  };
};
module.exports = Bless;
